// Equal Housing Opportunity mark. Paths copied from the inline EqualHousingIcon in pages/D2cLeadFlow.jsx
// (copied, not imported, so this kit has no dependency on that page).
export default function EqualHousing({ className = "", size = 32 }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path d="M4 14L16 5L28 14" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M7 13V26H25V13" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M11 19H21" stroke="currentColor" strokeWidth="2" />
      <path d="M11 23H21" stroke="currentColor" strokeWidth="2" />
      <text x="16" y="31" textAnchor="middle" fill="currentColor" style={{ fontSize: "4px", fontWeight: 700 }}>
        EQUAL HOUSING
      </text>
    </svg>
  )
}
